import React from 'react';
import ReactDOM from 'react-dom/client';

// CRÍTICO: Importar o CSS global aqui para carregar as fontes e estilos base.
import './index.css'; 

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);